<template lang="pug">
  div
    p These are the system IDs and origins for testing.
    form#apis.vertical.wide
      // User info other than address
      fieldset
        label Client Institution UUID
          input(type="text" v-model="settings.institutionId")
      // Backend API paths
      fieldset
        label Integrator ID Claim
          input(type="text" v-model="settings.integratorId")
        label Integrator API Origin
          input(type="text" v-model="settings.integratorOrigin")
        label SWBC Frame Origin
          input(type="text" v-model="settings.swbcOrigin")
    action-button.next-button(@click="save" title="Save")
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ActionButton from '@/components/ActionButton'
  export default {
    name: 'Quote',
    components: {
      ActionButton
    },
    data () {
      return {
        settings: {}
      }
    },
    methods: {
      ...mapActions(['setApis']),
      async save () {
        this.loading = true
        console.log(this.settings)
        try {
          await this.setApis(this.settings)
        } catch (err) {
          console.error(err)
        }
        this.loading = false
      }
    },
    computed: {
      ...mapGetters(['apis'])
    },
    created () {
      this.settings = this.apis
    }
  }
</script>

<style lang="sass">
  #apis
    display: flex
    flex-direction: column
    justify-content: flex-start
    align-items: center
    margin: 0 auto
</style>
